import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { SvgIconProps } from './Home'

const SvgSearchIcon = ({ fill }: SvgIconProps) => {
  const theme = useContext(ThemeContext)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        fill={fill ?? `${theme.colors.main}`}
        d="M21.607 19.695l-4.09-4.085c1.258-1.677 1.992-3.667 1.992-5.867 0-2.62-1.049-5.029-2.832-6.914C14.789 1.048 12.377 0 9.754 0 7.132 0 4.72 1.048 2.832 2.829 1.049 4.714 0 7.124 0 9.743c0 2.619 1.049 5.028 2.832 6.914 1.888 1.886 4.3 2.829 6.922 2.829 2.203 0 4.196-.629 5.874-1.99l4.09 4.085c.21.21.63.419.945.419.42 0 .734-.105.944-.419a1.327 1.327 0 000-1.886zm-4.825-9.952c0 1.886-.734 3.666-2.098 4.924-1.363 1.362-3.042 2.095-4.93 2.095-1.887 0-3.67-.733-4.93-2.095-1.363-1.362-2.097-3.038-2.097-4.924 0-1.886.734-3.667 2.098-4.924 1.363-1.362 3.042-2.095 4.93-2.095 1.887 0 3.67.733 4.93 2.095 1.363 1.257 2.097 3.038 2.097 4.924z"
      ></path>
    </svg>
  )
}

export default SvgSearchIcon